@let isVoided = isVoided$ | async;
@let elevatedAccess = elevatedAccess$ | async;
<div class="flex flex-col gap-medpace">
    <mds-divider />
    <div class="grid grid-cols-3 gap-medpace px-medpace">
        <div>
            <h5 class="font-bold">Date Requested</h5>
            <span>{{ request().createdTimestamp?.toDate() | dateFormat | uppercase }}</span>
        </div>
        <div>
            <h5 class="font-bold">Date Submitted</h5>
            <span>
                @if (request().submittedTimestamp) {
                    {{ request().submittedTimestamp?.toDate() | dateFormat | uppercase }}
                } @else {
                    Request was not submitted yet
                }
            </span>
        </div>
    </div>
    <div class="grid grid-cols-3 gap-medpace px-medpace">
        <div>
            <h5 class="font-bold">Requested ({{ request().currency }})</h5>
            <span>{{ (request().amount | number: '1.2-2' : 'en-US') ?? 'Unspecified' }}</span>
        </div>
        @if (isInProcessOrHigher() === true) {
            <div>
                <h5 class="font-bold">Authorized ({{ request().currency }})</h5>
                <span>{{ (request().authorizedAmount | number: '1.2-2' : 'en-US') ?? 'Unspecified' }}</span>
            </div>
        }
    </div>

    @if (isVoided && elevatedAccess) {
        <div>
            <medpace-payment-request-deduction-view
                [amount]="request().deducted"
                [amountConverted]="request().deductedUsd"
                [currency]="request().deductedCurrency"
            />
        </div>
    }
    @if (elevatedAccess) {
        <div class="grid grid-cols-3 gap-medpace px-medpace">
            <div>
                <h5 class="font-bold">Transaction Date</h5>
                <span>{{
                    request().transactionDate
                        ? (request().transactionDate | dateFormat: undefined : 'local' | uppercase)
                        : 'Unspecified'
                }}</span>
            </div>
            <div>
                <h5 class="font-bold">Merchant</h5>
                <span>{{ (merchant$ | async)?.viewValue ?? 'Unspecified' }}</span>
            </div>
        </div>
    }

    @if (isInProcessOrHigher() === true && elevatedAccess) {
        <div class="flex flex-row gap-medpace px-medpace">
            @if (authorizedAmountUSDChip()) {
                <mds-chip [chips]="authorizedAmountUSDChip()" [chipListType]="'basic'" [multiple]="true"></mds-chip>
            }
            @if (authorizedAmountPatientsCurrencyChip()) {
                <mds-chip
                    [chips]="authorizedAmountPatientsCurrencyChip()"
                    [chipListType]="'basic'"
                    [multiple]="true"
                ></mds-chip>
            }
        </div>
    }
    @if (isInProcessOrHigher() === true && elevatedAccess === true) {
        <div class="break-words">
            <h5>Notes</h5>
            <span>{{ request().notes ?? 'Unspecified' }}</span>
        </div>
    }
</div>
